"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createConnect_1 = require("./createConnect");
/**
 * Used to extract sorting information from Search API response and provide the handler,
 * to modify it further in components
 */
var _a = createConnect_1.default({
    field: 'meta:sort',
    mapProps: function (props) { return ({ selected: props && props.get(0) }); },
    handlers: {
        onChangeSort: function (_a) {
            var update = _a.update;
            return function (field, order) {
                return !field
                    ? update('sort')
                    : update('sort', [{ field: field, order: order }]);
            };
        }
    }
}), hook = _a[0], connect = _a[1];
exports.hook = hook;
exports.connect = connect;
//# sourceMappingURL=connectSort.js.map